import { Language } from '@components/LangSwitcher/types';

export const LanguageOptions: Array<Language> = [
  {
    label: 'English',
    shortCode: 'en',
  },
  {
    label: 'Русский',
    shortCode: 'ru',
  },
  {
    label: 'Қазақ',
    shortCode: 'kk',
  },
  {
    label: "O'zbek",
    shortCode: 'uz',
  },
  {
    label: 'Azərbaycan',
    shortCode: 'az',
  },
  {
    label: 'Кыргызча',
    shortCode: 'ky',
  },
  {
    label: 'Türkçe',
    shortCode: 'tr',
  },
  {
    label: 'ქართული',
    shortCode: 'ka',
  },
  {
    label: 'Português',
    shortCode: 'pt',
  },
  {
    label: 'Español',
    shortCode: 'es',
  },
  {
    label: 'Deutsch',
    shortCode: 'de',
  },
];

export const Languages = [
  'en',
  'ru',
  'kk',
  'uz',
  'az',
  'ky',
  'tr',
  'ka',
  'de',
  'es',
  'pt',
];
